
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    message: { type: String, default: '' },
    percent: { type: Number, default: 0 },
  },
  setup() {
    return {};
  },
});
